import React, { useMemo } from 'react';
import {
  useIntl,
  useDispatch,
  getLocale,
  useSelector,
  useLocation,
  history,
} from 'umi';
import UserGuideBox from '@/pages/home/components/UserGuideBox';
import { LANGUAGE_EN } from '@/pages/home/_config/config';
import { GUIDE_SYS_INTELLIGENCE } from '@/pages/home/models/guide';
import { storage } from '@/utils/utils';
import { DEFAULT_PC_GAMEID } from '@intelligence/components/UserGuide/utils';

export const INTELLIGENCE_GUIDE_HIDE = '__db_intelligence_guide_hide__';
export const INTELLIGENCE_GUIDE_BOX_LIST1 = '__db_intelligence_guide_list1__';
export const INTELLIGENCE_GUIDE_BOX_LIST2 = '__db_intelligence_guide_list2__';
export const INTELLIGENCE_GUIDE_BOX_LIST3 = '__db_intelligence_guide_list3__';
export const INTELLIGENCE_GUIDE_BOX_LIST4 = '__db_intelligence_guide_list4__';
export const INTELLIGENCE_GUIDE_BOX_LIST5 = '__db_intelligence_guide_list5__';
export const INTELLIGENCE_GUIDE_BOX_LIST6 = '__db_intelligence_guide_list6__';

export const INTELLIGENCE_GUIDE_BOX_LIST1_PATH = '/search?kw=pubg';
export const INTELLIGENCE_GUIDE_BOX_LIST2_PATH = '/search?kw=pubg&type=company';
export const INTELLIGENCE_GUIDE_BOX_LIST3_PATH = '/intelligence/genreProfile/pcGames';
export const INTELLIGENCE_GUIDE_BOX_LIST4_PATH = '/intelligence/reports/marketReports';
export const INTELLIGENCE_GUIDE_BOX_LIST5_PATH = `/intelligence/topCharts/pcGames/gamesDetails/${DEFAULT_PC_GAMEID}/stats/digitalRevenue`;
export const INTELLIGENCE_GUIDE_BOX_LIST6_PATH = '/intelligence/sourcesMetrics/sources';

export default () => {
  // 新手引导相关
  const locale = getLocale();
  const { formatMessage } = useIntl();
  const location = useLocation();
  const { pathname } = location;
  const { guideSys, userInfo } = useSelector((state: any) => {
    const {
      guide: { guideSys },
      home: { userInfo },
    } = state;
    return {
      guideSys,
      userInfo,
    };
  });

  const dispatch = useDispatch();

  const setShowGuide = (show: boolean): void => {
    dispatch({
      type: 'guide/showIntelligenceGuideModule',
      payload: show,
    });
  };

  // 模拟guide数据
  const GuideData = useMemo(() => {
    const { openid = '' } = userInfo || {};
    const list1 = storage.getLocalStorageItem(INTELLIGENCE_GUIDE_BOX_LIST1);
    const list2 = storage.getLocalStorageItem(INTELLIGENCE_GUIDE_BOX_LIST2);
    const list3 = storage.getLocalStorageItem(INTELLIGENCE_GUIDE_BOX_LIST3);
    const list4 = storage.getLocalStorageItem(INTELLIGENCE_GUIDE_BOX_LIST4);
    const list5 = storage.getLocalStorageItem(INTELLIGENCE_GUIDE_BOX_LIST5);
    const list6 = storage.getLocalStorageItem(INTELLIGENCE_GUIDE_BOX_LIST6);

    const blockList = [
      {
        tit: formatMessage({ id: 'dbi_user_guide_list1_title' }),
        des: formatMessage({ id: 'dbi_user_guide_list1_desc' }),
        checked: (list1 || []).includes(openid),
        onClick: () => {
          dispatch({
            type: 'guide/showIntelligenceGuideCompetitor',
          });
          if (pathname !== INTELLIGENCE_GUIDE_BOX_LIST1_PATH) {
            history.push(INTELLIGENCE_GUIDE_BOX_LIST1_PATH);
          }
        },
      },
      {
        tit: formatMessage({ id: 'dbi_user_guide_list2_title' }),
        des: formatMessage({ id: 'dbi_user_guide_list2_desc' }),
        checked: (list2 || []).includes(openid),
        onClick: () => {
          dispatch({
            type: 'guide/showIntelligenceGuideCompany',
          });
          if (pathname !== INTELLIGENCE_GUIDE_BOX_LIST2_PATH) {
            history.push(INTELLIGENCE_GUIDE_BOX_LIST2_PATH);
          }
        },
      },
      {
        tit: formatMessage({ id: 'dbi_user_guide_list3_title' }),
        des: formatMessage({ id: 'dbi_user_guide_list3_desc' }),
        checked: (list3 || []).includes(openid),
        onClick: () => {
          dispatch({
            type: 'guide/showIntelligenceGuideGenreMarketProfile',
          });
          if (pathname !== INTELLIGENCE_GUIDE_BOX_LIST3_PATH) {
            history.push(INTELLIGENCE_GUIDE_BOX_LIST3_PATH);
          }
        },
      },
      {
        tit: formatMessage({ id: 'dbi_user_guide_list4_title' }),
        des: formatMessage({ id: 'dbi_user_guide_list4_desc' }),
        checked: (list4 || []).includes(openid),
        onClick: () => {
          dispatch({
            type: 'guide/showIntelligenceGuideMarketReports',
          });
          if (pathname !== INTELLIGENCE_GUIDE_BOX_LIST4_PATH) {
            history.push(INTELLIGENCE_GUIDE_BOX_LIST4_PATH);
          }
        },
      },
      {
        tit: formatMessage({ id: 'dbi_user_guide_list5_title' }),
        des: formatMessage({ id: 'dbi_user_guide_list5_desc' }),
        checked: (list5 || []).includes(openid),
        onClick: () => {
          dispatch({
            type: 'guide/showIntelligenceGuideFollowing',
          });
          if (pathname !== INTELLIGENCE_GUIDE_BOX_LIST5_PATH) {
            history.push(INTELLIGENCE_GUIDE_BOX_LIST5_PATH);
          }
        },
      },
      {
        tit: formatMessage({ id: 'dbi_user_guide_list6_title' }),
        des: formatMessage({ id: 'dbi_user_guide_list6_desc' }),
        checked: (list6 || []).includes(openid),
        onClick: () => {
          dispatch({
            type: 'guide/showIntelligenceGuideSourcesMetrics',
          });
          if (pathname !== INTELLIGENCE_GUIDE_BOX_LIST6_PATH) {
            history.push(INTELLIGENCE_GUIDE_BOX_LIST6_PATH);
          }
        },
      },
    ];
    return {
      mainTitle: formatMessage({ id: 'dbi_user_guide_title' }),
      mainDes: formatMessage({ id: 'dbi_user_guide_desc' }),
      blockTitle: formatMessage({ id: 'dbh_dashboard_giudebox_block_title' }),
      blockList,
    };
  }, [locale, guideSys, userInfo, location]);

  return (
    guideSys === GUIDE_SYS_INTELLIGENCE &&
    userInfo && (
      <UserGuideBox
        className={`dbi-guidebox ${locale === LANGUAGE_EN ? 'en' : 'cn'}`}
        data={GuideData}
        setShowGuide={setShowGuide}
        guideHideKey={INTELLIGENCE_GUIDE_HIDE}
      />
    )
  );
};
